// import { TimePicker } from '@mui/x-date-pickers';
import moment from 'moment';
import { useState } from 'react';
import TableCompHead from '../../../../components/ui/TableCompHead';
import DatePickerMui from '../../../../components/common/DatePickerMui';
import formatDate from '../../../../components/common/formatDate';
import { TableInput } from '../../../../components/common';
import AutocompleteMuiCustom from '../../../../components/common/AutocompleteMuiCustom';
import { useQuery } from '../../../../hooks/UseQuery';
import { getDaysArr } from '../../helpers/utils';
import { Checkbox } from '@mui/material';
import { useAuth } from '../../../../services/auth/AuthProvider';

interface IProps {
  moduleData: any;
  handleHolidayCheckBox: any;
  isView: boolean;
}

// colspan 38

const THead = ({ moduleData, isView, handleHolidayCheckBox }: IProps) => {
  const [render, setRender] = useState(false);
  const annual_month = useQuery('annual_date') || '';
  const dayArr = getDaysArr(annual_month);
  const varColSpan = dayArr?.length || 31;
  const numberCol = dayArr.map(
    (item, index) => `${index + 1}-${item[index + 1].slice(0, 3)}`,
  );
  const { state } = useAuth();
  const theadData = [
    'Sr.No.',
    'Epmloyee Name',
    'Employee Id',
    'Designation',
    'Department',
    ...numberCol,
    'Remarks',
    'Delete Row',
  ];
  return (
    <thead>
      <TableCompHead
        colSpan={varColSpan + 2 + 5}
        rowSpan={1}
        labels={[]}
        values={[]}
        heading="Attendance Resister"
      />
      <tr>
        <th colSpan={2} align="left">
          Month:
        </th>
        <th colSpan={2 + 1} align="left">
          {moduleData.annual_month || annual_month}
        </th>
        {state.user?.userType === state.IS.Admin ? (
          moduleData.holidays?.map((holiday: any, index: number) => (
            <th key={index + 'checkbox'}>
              <Checkbox
                name="H"
                disabled={holiday === 'S'}
                checked={holiday === 'H'}
                onChange={(e) => {
                  handleHolidayCheckBox(index);
                }}
              />
            </th>
          ))
        ) : (
          <th colSpan={varColSpan}></th>
        )}
      </tr>
      <tr>
        {theadData.map((heading, index) => (
          <th key={heading} style={{ textTransform: 'uppercase' }}>
            {heading}
          </th>
        ))}
      </tr>
    </thead>
  );
};

export default THead;
